import angular from 'angular';
import moment from 'moment';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { IExclusaoLoteResultado, IGerenciamentoDocumento, IGerenciamentoDocumentoHistorico, GerenciamentoDocumentoSituacao } from '../models/gerenciamentodocumento.model';
import { GerenciamentoDocumentosService, GERENCIAMENTO_DOCUMENTOS_PAGE_LIMIT } from '../gerenciamentodocumentos.service';
import { MeurhVisualizarArquivoModalService } from '../../../Arquivos/modal/visualizararquivo/visualizararquivo.modal.service';
import { MeurhArquivosTrabalhadorService } from '../../../Arquivos/trabalhador/arquivos.trabalhador.service';
import { ConfirmacaoExclusaoModalService } from '../modal/confirmacao-exclusao.modal.service';
import { CancelarAssinaturaDocumentoModalService } from '../modal/cancelar-assinatura.modal.service';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../../utils/nsj-table';
import { Tiposcalculos } from '../../../Tiposcalculos/tiposcalculos.service';
import { TipoArquivosService } from '../../../TipoArquivos/tipo-arquivos.service';
import { ITipoArquivoResponse } from '../../../TipoArquivos/models/tipo-arquivos.service.model';
import { GruposPontoService } from '../../Ponto/gruposponto.service';
import { montarNomeArquivoComExtensao, resolverNomeArquivoDownload } from '@utils/utils';

type IGerenciamentoDocumentosFilters = {
    empresa?: string;
    estabelecimento?: string;
    lotacao?: {
        lotacao: string;
    } | null;
    grupoponto?: {
        grupo: string;
        nome?: string;
    } | null;
    tipodocumento?: string;
    competenciaano?: string | number;
    competenciames?: string | number;
    camposCustomizados?: Record<string, any>;
    situacao?: GerenciamentoDocumentoSituacao;
};

type HistoricoFiltro = 'all' | 'falhas' | 'manuais' | 'sistema';
type CampoCustomizadoTipo = 'select' | 'date' | 'text';

type ICampoCustomizadoConfiguracao = {
    campo: string;
    tipo?: string;
    label?: string;
    opcoes?: Array<{ id: string; nome: string }>;
};

type ITipoArquivoFiltrosEspecificos = {
    usar_competencia?: boolean;
    campos_customizados?: Array<string | ICampoCustomizadoConfiguracao>;
};

type ITipoDocumento = {
    id: string;
    nome: string;
    codigo?: string;
    filtros_especificos?: ITipoArquivoFiltrosEspecificos;
};

const LIMITE_DOWNLOAD_LOTE = 100;
const TAMANHO_MAXIMO_NOME_ARQUIVO = 150;
const NOME_DOCUMENTO_VAZIO = '—';

export class GerenciamentoDocumentosIndexController {
    static $inject = ['$scope', '$rootScope', 'ListagemService', 'GerenciamentoDocumentosService', 'TipoArquivosService', 'MeurhVisualizarArquivoModalService', 'MeurhArquivosTrabalhadorService', 'NewToaster', 'ConfirmacaoExclusaoModalService', 'CancelarAssinaturaDocumentoModalService', 'Tiposcalculos', 'GruposPontoService'];

    public entities: IGerenciamentoDocumento[] = [];
    public searchTerm = '';
    public checkboxPreenchidos: IGerenciamentoDocumento[] = [];
    public fields: Array<any> = [];
    public rotuloColunaData = 'Data geração';
    public busy = false;
    public liberacaoLoteBusy = false;
    public desfazerLiberacaoLoteBusy = false;
    public reenviarLoteBusy = false;
    public exclusaoLoteBusy = false;
    public downloadLoteBusy = false;
    public cancelamentoAssinaturaBusy = false;
    public carregandoPaginasAutomaticamente = false;
    public filterActive = false;
    public filters: IGerenciamentoDocumentosFilters = {
        camposCustomizados: {}
    };
    public empresas: Array<Empresa> = [];
    public estabelecimentos: Array<Estabelecimento> = [];
    public listagemPermissao: Array<string> = [];
    public permissaoGrupoEmpresarial = true;
    public entityService: GerenciamentoDocumentosService;
    public totalItems = 0;
    public currentPage = 1;
    public pageSize;

    public documentoSelecionado: IGerenciamentoDocumento | null = null;
    public historicoDocumento: IGerenciamentoDocumentoHistorico[] = [];
    public historicoAberto = false;
    public historicoFiltro: HistoricoFiltro = 'all';
    public historicoFiltros = [
        { label: 'Exibir todos', value: 'all' as const },
        { label: 'Apenas falhas', value: 'falhas' as const },
        { label: 'Apenas ações manuais', value: 'manuais' as const },
        { label: 'Apenas ações do sistema', value: 'sistema' as const }
    ];
    public tiposDocumentos: ITipoDocumento[] = [];
    public tiposDocumentosLoading = false;
    public exibeFiltroGrupoPonto = false;
    public tiposCalculos: any[] = [];
    public camposCustomizadosConfigurados: ICampoCustomizadoConfiguracao[] = [];
    public activeTabIndex = 0;
    public situacoesDocumentos: Array<{ label: string; value: GerenciamentoDocumentoSituacao }> = [
        { label: 'Pendente de liberação', value: GerenciamentoDocumentoSituacao.PendenteLiberacao },
        { label: 'Pendente de assinatura', value: GerenciamentoDocumentoSituacao.PendenteAssinatura },
        { label: 'Assinado', value: GerenciamentoDocumentoSituacao.Assinado },
        { label: 'Entregue', value: GerenciamentoDocumentoSituacao.Entregue },
        { label: 'Cancelado', value: GerenciamentoDocumentoSituacao.AssinaturaCancelada }
    ];
    public entitiesTrabalhadores: any;
    public totalPendenteLiberacao = 0;
    public totalPendenteAssinatura = 0;
    private destroyListeners: Array<() => void> = [];
    private hasNextPage = false;
    private pendenciasLoaded = false;
    private readonly camposCustomizadosDefinicoes: Record<string, { label: string; tipo: CampoCustomizadoTipo }> = {
        tipo_calculo: {
            label: 'Tipo de cálculo',
            tipo: 'select'
        },
        data_aviso: {
            label: 'Data do aviso',
            tipo: 'date'
        },
        periodo_aquisitivo_inicio: {
            label: 'Período aquisitivo inicial',
            tipo: 'date'
        },
        periodo_aquisitivo_fim: {
            label: 'Período aquisitivo final',
            tipo: 'date'
        },
        periodo_ferias_inicio: {
            label: 'Período de férias inicial',
            tipo: 'date'
        },
        periodo_ferias_fim: {
            label: 'Período de férias final',
            tipo: 'date'
        }
    };
    private readonly situacaoLabels: Record<GerenciamentoDocumentoSituacao, string> = {
        [GerenciamentoDocumentoSituacao.PendenteLiberacao]: 'Pendente de liberação',
        [GerenciamentoDocumentoSituacao.PendenteAssinatura]: 'Pendente de assinatura',
        [GerenciamentoDocumentoSituacao.Assinado]: 'Assinado',
        [GerenciamentoDocumentoSituacao.Entregue]: 'Entregue',
        [GerenciamentoDocumentoSituacao.AssinaturaCancelada]: 'Cancelado'
    };

    constructor(
        private $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            temPermissaoGrupoEmpresarial?: (permissoes: string[], grupo: string) => boolean;
            nsjGlobals?: any;
            session?: any;
            liberadoTela?: (param: string) => boolean;
        },
        public ListagemService: ListagemService,
        public GerenciamentoDocumentosService: GerenciamentoDocumentosService,
        public TipoArquivosService: TipoArquivosService,
        public MeurhVisualizarArquivoModalService: MeurhVisualizarArquivoModalService,
        public MeurhArquivosTrabalhadorService: MeurhArquivosTrabalhadorService,
        public NewToaster: any,
        public ConfirmacaoExclusaoModalService: ConfirmacaoExclusaoModalService,
        public CancelarAssinaturaDocumentoModalService: CancelarAssinaturaDocumentoModalService,
        public Tiposcalculos: Tiposcalculos,
        public GruposPontoService: GruposPontoService
    ) {
        this.entityService = this.GerenciamentoDocumentosService;
        this.tiposCalculos = this.Tiposcalculos.load();
        this.entityService.setPageSize(this.entityService.entities.length);
        this.entities = this.entityService.entities;
        this.searchTerm = this.entityService.filter || '';
        this.GerenciamentoDocumentosService.setFilterTerm('');
        this.hasNextPage = !this.entityService.loadParams.finished;
        this.pageSize = this.entityService.pagination.pageSize;
        this.currentPage = this.entityService.pagination.currentPage;
        this.totalItems = this.entityService.pagination.totalItems;

        this.addDestroyListener(this.$rootScope.$on('gerenciamentodocumentos_list_loading', () => {
            this.busy = true;
        }));

        this.addDestroyListener(this.$rootScope.$on('gerenciamentodocumentos_list_finished', (_event, payload?: { hasNext?: boolean }) => {
            this.decorateEntities();
            this.refreshCamposCustomizadosConfigurados();
            this.updatePaginationState();
            if (typeof payload?.hasNext === 'boolean') {
                this.hasNextPage = payload.hasNext;
            }
            this.applySearchFilter();
            this.busy = false;
        }));

        this.addDestroyListener(this.$rootScope.$on('gerenciamentodocumentos_list_error', () => {
            this.entities = [];
            this.totalItems = 0;
            this.busy = false;
            this.checkboxPreenchidos = [];
            this.totalPendenteLiberacao = 0;
            this.totalPendenteAssinatura = 0;
            this.hasNextPage = false;
        }));

        this.initializeListagem();
        this.carregarExibicaoFiltroGrupoPonto();
        this.loadPendencias();
        this.applySearchFilter();

        this.fields = applyNsjTableInlineMobileLabels([
            {
                value: 'matricula',
                label: 'Matrícula',
                type: 'string',
                style: 'title',
                copy: '',
            },
            {
                value: 'trabalhadorDisplay',
                label: 'Colaborador',
                type: 'string',
                style: 'title',
                copy: '',
            },
            {
                value: 'tipoarquivoTitulo',
                label: 'Tipo de documento',
                type: 'string',
                style: 'title',
                copy: '',
            },
            {
                value: 'nomeDocumentoDisplay',
                label: 'Nome do documento',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    const html = `
                        <span ng-class="{'nome-documento': tableRowEntity.nomeDocumentoDisplay !== '${NOME_DOCUMENTO_VAZIO}'}">
                            {{tableRowEntity.nomeDocumentoDisplay}}
                        </span>
                    `;

                    return html;
                },
            },
            {
                value: 'referencia',
                label: 'Referência',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    const html = `
                        <span>{{tableRowEntity.referencia}}</span>
                        <span
                            ng-if="tableRowEntity.campos_customizados.tipo_calculo"
                            class="tipo-calculo-tag"
                        >
                            {{tableRowEntity.campos_customizados.tipo_calculo}}
                        </span>
                    `;

                    return html;
                },
            },
            {
                value: 'datageracao',
                label: 'Data geração',
                type: 'string',
                style: 'title',
                copy: '',
                // o nsj-table compila o customLabelHtml uma vez so (e acrescenta, em vez
                // de trocar, se ele mudar): o rotulo vem por interpolacao para acompanhar a aba.
                customLabelHtml: buildNsjTableInlineMobileLabel('{{customLabelScope.rotulo()}}'),
                customLabelScope: { rotulo: () => this.rotuloColunaData },
            },
            {
                value: 'situacaoAtualLabel',
                label: 'Situação atual',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    const html = `
                        <span
                            class="situacao-chip {{tableRowEntity.situacaoClasse}}"
                        >
                            {{tableRowEntity.situacaoAtualLabel}}
                        </span>
                    `;

                    return html;
                },
            },
            {
                value: 'id',
                label: 'Ações',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnScope: {
                    visualizarDocumento: (entity: IGerenciamentoDocumento) => {
                        this.visualizarDocumento(entity);
                    },
                    baixarDocumento: (entity: IGerenciamentoDocumento) => {
                        this.baixarDocumento(entity);
                    },
                    verHistorico: (entity: IGerenciamentoDocumento) => {
                        this.verHistorico(entity);
                    },
                    cancelarAssinatura: (entity: IGerenciamentoDocumento) => {
                        this.cancelarAssinatura(entity);
                    },
                    liberarDocumento: (entity: IGerenciamentoDocumento) => {
                        this.liberarDocumento(entity);
                    },
                    reenviarDocumento: (entity: IGerenciamentoDocumento) => {
                        this.reenviarDocumento(entity);
                    },
                    desfazerLiberacao: (entity: IGerenciamentoDocumento) => {
                        this.desfazerLiberacao(entity);
                    },
                    podeLiberar: (entity: IGerenciamentoDocumento) => {
                        return this.podeLiberar(entity);
                    },
                    podeDesfazerLiberacao: (entity: IGerenciamentoDocumento) => {
                        return this.podeDesfazerLiberacao(entity);
                    },
                    podeReenviar: (entity: IGerenciamentoDocumento) => {
                        return this.podeReenviar(entity);
                    },
                    podeCancelarAssinatura: (entity: IGerenciamentoDocumento) => {
                        return this.podeCancelarAssinatura(entity);
                    },
                    excluirDocumento: (entity: IGerenciamentoDocumento) => {
                        this.excluirDocumento(entity);
                    },
                    podeExcluir: (entity: IGerenciamentoDocumento) => {
                        return this.podeExcluir(entity);
                    }
                },
                customCollumnHtml: () => {
                    const actionsHtml = `
                        <div class="display-flex">
                            <a
                                class="btn btn-default btn-sm"
                                ng-click="customCollumnScope.visualizarDocumento(entity)"
                                uib-tooltip="Visualizar documento"
                                tooltip-placement="top"
                                aria-label="Visualizar documento"
                            >
                                <i class="fas fa-eye"></i>
                            </a>
                            <nsj-button-dropdown
                                border="none"
                                split="false"
                                size="sm"
                                icon="fas fa-ellipsis-h"
                                dropdown-direction="right"
                                class="menuEllipsis"
                            >
                                <item-dropdown
                                    class="gd-dropdown-item"
                                    item-label="Baixar documento"
                                    ng-click="customCollumnScope.baixarDocumento(entity)"
                                ></item-dropdown>
                                <item-dropdown
                                    class="gd-dropdown-item"
                                    item-label="Ver histórico"
                                    ng-click="customCollumnScope.verHistorico(entity)"
                                ></item-dropdown>
                                <item-dropdown
                                    class="gd-dropdown-item"
                                    item-label="Cancelar documento"
                                    ng-click="customCollumnScope.cancelarAssinatura(entity)"
                                    ng-disabled="!customCollumnScope.podeCancelarAssinatura(entity)"
                                    ng-class="{'disabled': !customCollumnScope.podeCancelarAssinatura(entity)}"
                                ></item-dropdown>
                                <item-dropdown
                                    class="gd-dropdown-item"
                                    item-label="Liberar documento"
                                    ng-click="customCollumnScope.liberarDocumento(entity)"
                                    ng-disabled="!customCollumnScope.podeLiberar(entity)"
                                ></item-dropdown>
                                <item-dropdown
                                    class="gd-dropdown-item"
                                    item-label="Reenviar"
                                    ng-click="customCollumnScope.reenviarDocumento(entity)"
                                    ng-disabled="!customCollumnScope.podeReenviar(entity)"
                                    ng-class="{'disabled': !customCollumnScope.podeReenviar(entity)}"
                                ></item-dropdown>
                                <item-dropdown
                                    class="gd-dropdown-item"
                                    item-label="Desfazer liberação"
                                    ng-click="customCollumnScope.desfazerLiberacao(entity)"
                                    ng-disabled="!customCollumnScope.podeDesfazerLiberacao(entity)"
                                    ng-class="{'disabled': !customCollumnScope.podeDesfazerLiberacao(entity)}"
                                ></item-dropdown>
                                <item-dropdown
                                    class="gd-dropdown-item"
                                    item-label="Excluir documento"
                                    ng-click="customCollumnScope.excluirDocumento(entity)"
                                    ng-disabled="!customCollumnScope.podeExcluir(entity)"
                                    ng-class="{'disabled': !customCollumnScope.podeExcluir(entity)}"
                                ></item-dropdown>
                            </nsj-button-dropdown>
                        </div>
                    `;
                    return actionsHtml;
                }
            }
        ]);

        this.updateDataColumnConfig();
        this.filterReload();

        this.$scope.$on('$destroy', () => {
            this.onDestroy();
        });
    }


    carregarTiposDocumentos(): void {
        this.tiposDocumentosLoading = true;

        const constructors = { ...this.setConstructor() };
        delete constructors.tipoarquivo;
        delete constructors.competenciaano;
        delete constructors.competenciames;
        delete constructors.campos_customizados;
        delete constructors.grupo;

        this.TipoArquivosService
            .getList(constructors)
            .then((tipos: ITipoArquivoResponse[]) => {
                this.tiposDocumentos = tipos
                    .map((item) => {
                        return {
                            id: item.tipoarquivo,
                            nome: item.titulo,
                            codigo: item.codigo,
                            filtros_especificos: item.filtros_especificos || {
                                usar_competencia: false,
                                campos_customizados: []
                            }
                        };
                    });
                this.normalizarFiltrosEspecificosTipoSelecionado();
            })
            .catch(() => {
                this.tiposDocumentos = [];
            })
            .finally(() => {
                this.tiposDocumentosLoading = false;
            });
    }

    /**
     * O filtro de grupo de ponto só aparece quando há grupos para o usuário escolher.
     */
    carregarExibicaoFiltroGrupoPonto(): void {
        this.GruposPontoService
            ._load({}, {}, '')
            .then((grupos: any) => {
                this.exibeFiltroGrupoPonto = Array.isArray(grupos) && grupos.length > 0;
            })
            .catch(() => {
                this.exibeFiltroGrupoPonto = false;
            });
    }

    initializeListagem(): void {
        const grupoEmpresarial = this.$rootScope?.nsjGlobals?.a?.grupoempresarial;

        this.permissaoGrupoEmpresarial = this.canVisualizarTodasEmpresas(grupoEmpresarial);

        if (grupoEmpresarial) {
            this.empresas = this.ListagemService.montaEmpresas(grupoEmpresarial, this.listagemPermissao);
        }

        const empresaPadrao = this.$rootScope?.session?.entities?.empresa?.empresa;
        const estabelecimentoPadrao = this.$rootScope?.session?.entities?.estabelecimento?.estabelecimento;

        const filtrosIniciais: IGerenciamentoDocumentosFilters = {
            ...this.filters
        };

        if (!filtrosIniciais.situacao) {
            filtrosIniciais.situacao = GerenciamentoDocumentoSituacao.PendenteLiberacao;
        }

        if (empresaPadrao) {
            filtrosIniciais.empresa = empresaPadrao;
        }

        if (estabelecimentoPadrao) {
            filtrosIniciais.estabelecimento = estabelecimentoPadrao;
        }

        this.filters = filtrosIniciais;
        this.activeTabIndex = this.resolveActiveTabIndex(this.filters.situacao);

        if (this.filters.empresa) {
            this.estabelecimentos = this.ListagemService.montaEstabelecimentos(
                this.filters.empresa,
                this.empresas,
                this.listagemPermissao
            );
        }
    }

    public mudaEstabelecimentos(): void {
        this.estabelecimentos = this.filters.empresa
            ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao)
            : [];

        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    public filtraEmpresaEstabelecimento(): void {
        if (this.filters.lotacao) {
            delete this.filters.lotacao;
        }

        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
        this.filterReload();
    }

    public constructorEmpresaEstabelecimento() {
        return {
            empresa: this.filters.empresa,
            estabelecimento: this.filters.estabelecimento
        };
    }

    /**
     * Divide a linha de filtros avançados entre os filtros visíveis: lotação sempre,
     * empresa e estabelecimento conforme a liberação e grupo de ponto quando há grupos.
     */
    public classeColunaFiltroAvancado(): string {
        const exibeEmpresaEstabelecimento = !!this.$rootScope.liberadoTela?.('LIBERAR_REFATORACAO_VISIBILIDADE');
        const quantidadeFiltros = 1 + (exibeEmpresaEstabelecimento ? 2 : 0) + (this.exibeFiltroGrupoPonto ? 1 : 0);

        return `col-md-${12 / quantidadeFiltros} col-sm-12`;
    }

    public filterReload(): void {
        this.normalizarFiltrosEspecificosTipoSelecionado();
        this.loadPendencias();
        this.updateDataColumnConfig();
        const constructors = this.setConstructor();
        this.GerenciamentoDocumentosService.setConstructors(constructors);
        this.GerenciamentoDocumentosService.setFilters(constructors);
        this.checkboxPreenchidos = [];
        this.currentPage = 1;
        this.carregarTiposDocumentos();
        this.busy = true;
        this.carregandoPaginasAutomaticamente = this.devePaginarPendentesAutomaticamente() && !this.hasSearchActive();

        this.entityService
            .reload()
            .then(() => {
                this.carregarPendentesAutomaticamente();
            })
            .catch(() => {
                this.busy = false;
                this.carregandoPaginasAutomaticamente = false;
                this.entities = [];
            });
    }

    public search(): void {
        this.currentPage = 1;
        this.applySearchFilter();
    }

    public onTipoDocumentoChange(): void {
        this.normalizarFiltrosEspecificosTipoSelecionado();
        this.filterReload();
    }

    public applySearchFilter(): void {
        const normalizedTerm = this.normalizeSearchValue(this.searchTerm);
        const tipoCalculoSelecionado = this.normalizeSearchValue(this.filters.camposCustomizados?.tipo_calculo);
        const baseEntities = this.entityService.entities || [];

        this.entities = baseEntities.filter((documento) => {
            const matchesSearch = !normalizedTerm || this.matchesSearch(documento, normalizedTerm);
            const matchesTipoCalculo = !tipoCalculoSelecionado || this.matchesTipoCalculo(documento, tipoCalculoSelecionado);

            return matchesSearch && matchesTipoCalculo;
        });

        this.syncCheckboxSelections();
        this.updateLoadMoreState(!!normalizedTerm || !!tipoCalculoSelecionado);
    }

    matchesSearch(documento: IGerenciamentoDocumento, normalizedTerm: string): boolean {
        if (!documento) {
            return false;
        }

        const nome = this.normalizeSearchValue(
            documento.trabalhadorDisplay || (documento.trabalhador && documento.trabalhador.nome)
        );
        const matricula = this.normalizeSearchValue(
            documento.matricula || (documento.trabalhador && documento.trabalhador.codigo)
        );
        const nomeDocumento = this.normalizeSearchValue(documento.nome);

        return nome.includes(normalizedTerm)
            || matricula.includes(normalizedTerm)
            || nomeDocumento.includes(normalizedTerm);
    }

    matchesTipoCalculo(documento: IGerenciamentoDocumento, tipoCalculoSelecionado: string): boolean {
        if (!tipoCalculoSelecionado) {
            return true;
        }

        const valoresTipoCalculo = this.extrairValoresTipoCalculo(documento?.campos_customizados?.tipo_calculo);

        return valoresTipoCalculo.some((valor) => this.normalizeSearchValue(valor) === tipoCalculoSelecionado);
    }

    normalizeSearchValue(value: string | number | null | undefined): string {
        if (value === null || value === undefined) {
            return '';
        }

        const text = value.toString().toLowerCase().trim();

        if (typeof text.normalize === 'function') {
            return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }

        return text;
    }

    public setConstructor() {
        const params: Record<string, any> = {};

        if (this.filters.situacao) {
            params.status = this.filters.situacao;
        }

        const tipoDocumentoFiltro = this.filters.tipodocumento;

        if (tipoDocumentoFiltro) {
            params.tipoarquivo = tipoDocumentoFiltro;
        }

        if (this.filters.empresa) {
            params['trabalhador.empresa'] = this.filters.empresa;
        }

        if (this.filters.estabelecimento) {
            params['trabalhador.estabelecimento'] = this.filters.estabelecimento;
        }

        if (this.filters.lotacao?.lotacao) {
            params['trabalhador.lotacao'] = this.filters.lotacao.lotacao;
        }

        if (this.filters.grupoponto?.grupo) {
            params.grupo = this.filters.grupoponto.grupo;
        }

        if (this.filters.competenciaano) {
            params.competenciaano = this.filters.competenciaano;
        }

        if (this.filters.competenciames) {
            params.competenciames = this.filters.competenciames;
        }

        const camposCustomizados = this.buildCamposCustomizadosParams();

        if (Object.keys(camposCustomizados).length) {
            params.campos_customizados = camposCustomizados;
        }

        return params;
    }

    public deveDesabilitarCompetencia(): boolean {
        const tipoDocumentoSelecionado = this.getTipoDocumentoSelecionado();

        return !!tipoDocumentoSelecionado && !tipoDocumentoSelecionado.filtros_especificos?.usar_competencia;
    }

    public getCampoCustomizadoLabel(campo: string | ICampoCustomizadoConfiguracao): string {
        const configuracao = this.normalizarCampoCustomizadoConfiguracao(campo);

        if (!configuracao) {
            return '';
        }

        return configuracao.label || this.camposCustomizadosDefinicoes[configuracao.campo]?.label || configuracao.campo;
    }

    public isCampoCustomizadoSelect(campo: string | ICampoCustomizadoConfiguracao): boolean {
        return this.getCampoCustomizadoTipo(campo) === 'select';
    }

    public isCampoCustomizadoDate(campo: string | ICampoCustomizadoConfiguracao): boolean {
        return this.getCampoCustomizadoTipo(campo) === 'date';
    }

    public isCampoCustomizadoText(campo: string | ICampoCustomizadoConfiguracao): boolean {
        return this.getCampoCustomizadoTipo(campo) === 'text';
    }

    public syncCheckboxSelections(): void {
        if (!this.checkboxPreenchidos.length) {
            return;
        }

        const entidadesPorId = new Map(
            this.entities
                .filter((documento) => documento.id || documento.arquivotrabalhador)
                .map((documento) => [
                    (documento.id || documento.arquivotrabalhador || '').toString(),
                    documento
                ] as const)
        );

        const selecionadosAtualizados: IGerenciamentoDocumento[] = [];
        const idsInseridos = new Set<string>();

        this.checkboxPreenchidos.forEach((documento) => {
            const documentoChave = (documento.id || documento.arquivotrabalhador || '').toString();

            if (!documentoChave) {
                return;
            }

            const entidadeAtualizada = entidadesPorId.get(documentoChave);

            if (entidadeAtualizada) {
                const chave = (entidadeAtualizada.id || entidadeAtualizada.arquivotrabalhador || '').toString();

                if (chave && !idsInseridos.has(chave)) {
                    selecionadosAtualizados.push(entidadeAtualizada);
                    idsInseridos.add(chave);
                }
            }
        });

        this.checkboxPreenchidos = selecionadosAtualizados;
    }

    public loadMore(): void {
        if (this.hasSearchActive()) {
            return;
        }

        if (this.carregandoPaginasAutomaticamente) {
            return;
        }

        if (this.entityService.loadParams.busy || this.entityService.loadParams.finished) {
            return;
        }

        this.entityService.loadNextPage().catch(() => {
            this.busy = false;
        });
    }

    public carregarPendentesAutomaticamente(): void {
        // para pendentes, carrega todas as paginas automaticamente ate retornar menos do que o limite da consulta.
        if (!this.devePaginarPendentesAutomaticamente() || this.hasSearchActive()) {
            this.carregandoPaginasAutomaticamente = false;
            return;
        }

        if (this.entityService.loadParams.finished) {
            this.carregandoPaginasAutomaticamente = false;
            return;
        }

        this.carregandoPaginasAutomaticamente = true;
        const previousCount = this.entityService.entities.length;
        const pageSize = this.entityService.pagination.pageSize || GERENCIAMENTO_DOCUMENTOS_PAGE_LIMIT;

        this.entityService
            .loadNextPage()
            .then((entities) => {
                const delta = entities.length - previousCount;

                if (delta >= pageSize && this.devePaginarPendentesAutomaticamente()) {
                    this.carregarPendentesAutomaticamente();
                    return;
                }

                this.carregandoPaginasAutomaticamente = false;
            })
            .catch(() => {
                this.busy = false;
                this.carregandoPaginasAutomaticamente = false;
            });
    }

    public decorateEntities(): void {
        if (!this.pendenciasLoaded) {
            this.totalPendenteLiberacao = 0;
            this.totalPendenteAssinatura = 0;
        }

        this.entityService.entities.forEach((documento) => {
            if (!documento.id && documento.arquivotrabalhador) {
                documento.id = documento.arquivotrabalhador;
            }
            documento.matricula = this.resolveMatricula(documento.trabalhador);
            documento.trabalhadorDisplay = this.resolveTrabalhadorDisplay(documento.trabalhador);
            documento.tipoarquivoTitulo = documento.tipoarquivo.titulo;
            documento.nomeDocumentoDisplay = this.resolveNomeDocumento(documento.nome);
            documento.referencia = this.resolveReferencia(
                documento.competenciames,
                documento.competenciaano
            );
            documento.datageracao = this.resolveDataGeracao(documento.datarecebimento);
            documento.dataliberacao = this.resolveDataGeracao(documento.dataliberacao);
            documento.dataassinaturaDisplay = this.resolveDataGeracao(documento.data_assinatura as string);
            documento.prazoassinaturaDisplay = this.resolvePrazoAssinatura(documento);
            documento.datacancelamentoDisplay = this.resolveDataLocal(documento.data_cancelamento);
            this.definirSituacaoAtual(documento);
        });
    }

    public resolveMatricula(trabalhador: IGerenciamentoDocumento['trabalhador']): string {
        if (!trabalhador || typeof trabalhador === 'string') {
            return '';
        }

        return trabalhador.codigo || '';
    }

    public resolveTrabalhadorDisplay(trabalhador: IGerenciamentoDocumento['trabalhador']): string {
        if (!trabalhador) {
            return '-';
        }

        return trabalhador.nome;
    }

    public resolveNomeDocumento(nome: IGerenciamentoDocumento['nome']): string {
        return (nome && nome.trim()) || NOME_DOCUMENTO_VAZIO;
    }

    public resolveDataGeracao(createdAt: IGerenciamentoDocumento['datarecebimento']): string {
        if (!createdAt) {
            return '-';
        }

        if (typeof createdAt === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(createdAt)) {
            return createdAt;
        }

        const data = moment.parseZone(createdAt);

        if (!data.isValid()) {
            return '-';
        }

        return data.format('DD/MM/YYYY');
    }

    /**
     * Para instantes gravados em UTC (ex.: created_at do historico): converte para o
     * horario local antes de exibir. Nao serve para o datarecebimento, que e uma data
     * pura gravada a meia-noite UTC e voltaria um dia.
     */
    public resolveDataLocal(valor?: string | null): string {
        if (!valor) {
            return '-';
        }

        const data = moment.utc(valor);

        return data.isValid() ? data.local().format('DD/MM/YYYY') : '-';
    }

    public resolvePrazoAssinatura(documento: IGerenciamentoDocumento): string {
        if (!documento.datasolicitacaoassinatura || !documento.prazoassinatura) {
            return '-';
        }

        const dataSolicitacao = moment.parseZone(documento.datasolicitacaoassinatura);

        if (!dataSolicitacao.isValid()) {
            return '-';
        }

        const prazoDias = typeof documento.prazoassinatura === 'string'
            ? parseInt(documento.prazoassinatura, 10)
            : documento.prazoassinatura;

        if (!Number.isFinite(prazoDias)) {
            return '-';
        }

        return dataSolicitacao.add(prazoDias as number, 'days').format('DD/MM/YYYY');
    }

    public updateDataColumnConfig(): void {
        if (!this.fields.length) {
            return;
        }

        const dataColumn = this.fields.find((field) =>
            field.value === 'datageracao' ||
            field.value === 'dataliberacao' ||
            field.value === 'prazoassinaturaDisplay' ||
            field.value === 'dataassinaturaDisplay' ||
            field.value === 'datacancelamentoDisplay'
        );

        if (!dataColumn) {
            return;
        }

        const isEntregue = this.filters?.situacao === GerenciamentoDocumentoSituacao.Entregue;
        const isPendenteAssinatura = this.filters?.situacao === GerenciamentoDocumentoSituacao.PendenteAssinatura;
        const isAssinado = this.filters?.situacao === GerenciamentoDocumentoSituacao.Assinado;
        const isCancelado = this.filters?.situacao === GerenciamentoDocumentoSituacao.AssinaturaCancelada;

        if (isEntregue) {
            this.definirColunaData(dataColumn, 'dataliberacao', 'Data liberação');
            return;
        }

        if (isAssinado) {
            this.definirColunaData(dataColumn, 'dataassinaturaDisplay', 'Data assinatura');
            return;
        }

        if (isPendenteAssinatura) {
            this.definirColunaData(dataColumn, 'prazoassinaturaDisplay', 'Data limite');
            return;
        }

        if (isCancelado) {
            this.definirColunaData(dataColumn, 'datacancelamentoDisplay', 'Data cancelamento');
            return;
        }

        this.definirColunaData(dataColumn, 'datageracao', 'Data geração');
    }

    public resolveReferencia(
        mes?: string | number | null,
        ano?: string | number | null
    ): string {
        if (!mes && !ano) {
            return '-';
        }

        const mesNumero = typeof mes === 'string' ? parseInt(mes, 10) : mes;
        const anoNumero = typeof ano === 'string' ? parseInt(ano, 10) : ano;

        const mesValido = Number.isFinite(mesNumero) && mesNumero! >= 1 && mesNumero! <= 12;
        const anoValido = Number.isFinite(anoNumero) && anoNumero! > 0;

        if (!mesValido && !anoValido) {
            return '';
        }

        const mesFormatado = mesValido ? this.obterNomeMes(mesNumero!) : '';

        if (mesFormatado && anoValido) {
            return `${mesFormatado}/${anoNumero}`;
        }

        return mesFormatado || (anoValido ? anoNumero!.toString() : '');
    }

    public obterNomeMes(mes: number): string {
        const nomes = [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'
        ];

        if (mes >= 1 && mes <= 12) {
            return nomes[mes - 1];
        }

        return mes.toString().padStart(2, '0');
    }

    public definirSituacaoAtual(documento: IGerenciamentoDocumento): void {
        const situacao = this.resolveSituacaoAtual(documento);
        documento.situacaoAtual = situacao.value;
        documento.situacaoAtualLabel = situacao.label;
        documento.situacaoClasse = this.getSituacaoClasse(situacao.label);

        if (!this.pendenciasLoaded &&
            situacao.value === GerenciamentoDocumentoSituacao.PendenteLiberacao) {
            this.totalPendenteLiberacao += 1;
        }

        if (!this.pendenciasLoaded &&
            situacao.value === GerenciamentoDocumentoSituacao.PendenteAssinatura) {
            this.totalPendenteAssinatura += 1;
        }
    }

    public loadPendencias(): void {
        this.pendenciasLoaded = false;
        this.totalPendenteLiberacao = 0;
        this.totalPendenteAssinatura = 0;

        this.GerenciamentoDocumentosService
            .getPendencias(this.setConstructor())
            .then((pendencias: Array<{ qtd_pendente_liberacao?: number; qtd_pendente_assinatura?: number }>) => {
                const totals = pendencias.reduce(
                    (acc, item) => {
                        acc.liberacao += Number(item.qtd_pendente_liberacao || 0);
                        acc.assinatura += Number(item.qtd_pendente_assinatura || 0);
                        return acc;
                    },
                    { liberacao: 0, assinatura: 0 }
                );

                this.totalPendenteLiberacao = totals.liberacao;
                this.totalPendenteAssinatura = totals.assinatura;
                this.pendenciasLoaded = true;
            })
            .catch(() => {
                this.pendenciasLoaded = false;
            });
    }

    public resolveSituacaoAtual(
        documento: IGerenciamentoDocumento
    ): { value: GerenciamentoDocumentoSituacao; label: string } | any {
        const construirSituacao = (value: GerenciamentoDocumentoSituacao) => ({
            value,
            label: this.situacaoLabels[value] || value
        });

        if (documento.situacaoassinatura === 4) {
            return construirSituacao(GerenciamentoDocumentoSituacao.AssinaturaCancelada);
        }

        if (documento.situacaoliberacao === false) {
            return construirSituacao(GerenciamentoDocumentoSituacao.PendenteLiberacao);
        }

        if (documento.situacaoassinatura === 2) {
            return construirSituacao(GerenciamentoDocumentoSituacao.Assinado);
        }

        if (documento.situacaoassinatura === 1) {
            return construirSituacao(GerenciamentoDocumentoSituacao.PendenteAssinatura);
        }

        if (documento.situacaoliberacao) {
            return construirSituacao(GerenciamentoDocumentoSituacao.Entregue);
        }

        return;
    }

    public getSituacaoClasse(situacao: string): string {
        switch (situacao) {
            case 'Entregue':
            case 'Assinado':
                return 'situacao-chip--success';
            case 'Pendente de assinatura':
                return 'situacao-chip--pending-signature';
            case 'Cancelado':
                return 'situacao-chip--neutral';
            default:
                return 'situacao-chip--warning';
        }
    }

    public updatePaginationState(): void {
        const { currentPage, pageSize, totalItems } = this.entityService.pagination;
        this.currentPage = currentPage;
        this.pageSize = pageSize;
        this.totalItems = totalItems;
    }

    public canVisualizarTodasEmpresas(grupo?: string): boolean {
        if (!this.listagemPermissao.length) {
            return true;
        }

        if (!grupo || typeof this.$rootScope.temPermissaoGrupoEmpresarial !== 'function') {
            return false;
        }

        return this.$rootScope.temPermissaoGrupoEmpresarial(this.listagemPermissao, grupo);
    }

    public checar_todos(): void {
        const checkToggle = document.getElementById('check_all') as HTMLInputElement | null;

        if (!checkToggle) {
            return;
        }

        if (this.selecionarTodosDesabilitado()) {
            checkToggle.checked = this.temTodosMarcados();
            checkToggle.indeterminate = this.naoTemTodosMarcados();
            return;
        }

        if (checkToggle.checked && !checkToggle.indeterminate) {
            const selectable = this.entities.filter((documento) => !documento.disableCheckbox);
            this.checkboxPreenchidos = angular.copy(selectable);
        } else {
            this.checkboxPreenchidos = [];
        }
    }

    public temTodosMarcados(): boolean {
        const totalSelecionaveis = this.entities.filter((documento) => !documento.disableCheckbox).length;
        return !!totalSelecionaveis && this.checkboxPreenchidos.length === totalSelecionaveis;
    }

    public naoTemTodosMarcados(): boolean {
        return !!this.checkboxPreenchidos.length && !this.temTodosMarcados();
    }

    public carregandoSelecaoEmMassa(): boolean {
        const carregandoListaPendente = this.devePaginarPendentesAutomaticamente()
            && !this.hasSearchActive()
            && !this.entityService.loadParams.finished;

        return !!this.entities.length
            && (
                this.carregandoPaginasAutomaticamente
                || !!this.entityService.loadParams.busy
                || carregandoListaPendente
            );
    }

    public selecionarTodosDesabilitado(): boolean {
        return !this.entities.length
            || this.busy
            || this.carregandoSelecaoEmMassa();
    }

    public getRowCustomClass(documento: IGerenciamentoDocumento): string {
        return documento.rowcustomclass || '';
    }

    public visualizarDocumento(documento: IGerenciamentoDocumento): void {
        if (!documento?.arquivotrabalhador) {
            console.error('Documento sem ID de arquivo');
            return;
        }

        const extensao = this.resolverExtensaoDocumento(documento);
        const modalInstance = this.MeurhVisualizarArquivoModalService.open(
            documento.arquivotrabalhador,
            extensao,
            this.MeurhArquivosTrabalhadorService
        );

        modalInstance.result.catch(() => { /* noop */ });
    }

    public baixarDocumento(documento: IGerenciamentoDocumento): void {
        if (!documento.arquivotrabalhador) {
            console.error('Documento sem ID de arquivo');
            return;
        }

        this.busy = true;

        this.baixarArquivoIndividual(documento)
            .catch((error) => {
                console.error('Erro ao baixar documento:', error);
            })
            .finally(() => {
                this.busy = false;
            });
    }

    public verHistorico(_documento: IGerenciamentoDocumento): void {
        this.documentoSelecionado = _documento;
        this.historicoAberto = true;
        this.historicoFiltro = 'all';
        this.historicoDocumento = [];

        if (!_documento.arquivotrabalhador) {
            return;
        }

        this.GerenciamentoDocumentosService.getHistorico(_documento.arquivotrabalhador)
            .then((historico) => {
                this.historicoDocumento = this.transformarHistorico(historico);
            })
            .catch((error) => {
                console.error('Erro ao carregar histórico:', error);
                this.historicoDocumento = [];
            });
    }

    public fecharHistorico(): void {
        this.historicoAberto = false;
        this.historicoDocumento = [];
        this.documentoSelecionado = null;
    }

    public getHistoricoFiltrado(): IGerenciamentoDocumentoHistorico[] {
        if (this.historicoFiltro === 'all') {
            return this.historicoDocumento;
        }

        const filtroCategoria: Record<HistoricoFiltro, IGerenciamentoDocumentoHistorico['categoria'] | null> = {
            all: null,
            falhas: 'falha',
            manuais: 'manual',
            sistema: 'sistema'
        };

        const categoria = filtroCategoria[this.historicoFiltro];

        return this.historicoDocumento.filter((evento) => evento.categoria === categoria);
    }

    public getEventoIndicatorClass(evento: IGerenciamentoDocumentoHistorico): string {
        switch (evento.categoria) {
            case 'sistema':
                return 'indicator--success';
            case 'manual':
                return 'indicator--info';
            case 'falha':
                return 'indicator--warning';
            default:
                return 'indicator--info';
        }
    }

    public liberarDocumento(documento: IGerenciamentoDocumento): void {
        if (!documento.arquivotrabalhador) {
            console.error('Documento sem ID de arquivo');
            return;
        }

        if (!this.podeLiberar(documento)) {
            return;
        }

        this.busy = true;

        this.GerenciamentoDocumentosService.liberarDocumento(documento.arquivotrabalhador)
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Documento liberado com sucesso!'
                });

                this.filterReload();
            })
            .catch((error) => {
                console.error('Erro ao liberar documento:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao liberar documento',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar liberar o documento. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    public podeLiberar(documento: IGerenciamentoDocumento): boolean {
        return documento.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteLiberacao;
    }

    public podeDesfazerLiberacao(documento: IGerenciamentoDocumento): boolean {
        if (documento.situacaoassinatura === 2) {
            return false;
        }

        if (documento.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteLiberacao) {
            return false;
        }

        return documento.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteAssinatura ||
            documento.situacaoAtual === GerenciamentoDocumentoSituacao.Entregue;
    }

    public podeReenviar(documento: IGerenciamentoDocumento): boolean {
        if (documento.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteLiberacao) {
            return false;
        }
        return documento.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteAssinatura ||
            documento.situacaoAtual === GerenciamentoDocumentoSituacao.Entregue;
    }

    public podeCancelarAssinatura(documento: IGerenciamentoDocumento): boolean {
        return !!documento?.arquivotrabalhador
            && documento.situacaoassinatura === 2
            && documento.tipoarquivo?.codigo !== 'FOLHA_PONTO';
    }

    public cancelarAssinatura(documento: IGerenciamentoDocumento): void {
        if (!this.podeCancelarAssinatura(documento)) {
            return;
        }

        const modalInstance = this.CancelarAssinaturaDocumentoModalService.open(documento);

        modalInstance.result.then((comentario: string) => {
            this.executarCancelamentoAssinatura(documento, comentario);
        }).catch(() => { /* cancelado */ });
    }

    public podeLiberarSelecionados(): boolean {
        if (this.liberacaoLoteBusy || this.desfazerLiberacaoLoteBusy) {
            return false;
        }

        const idsLiberaveis = this.coletarIdsDocumentosLiberaveisSelecionados();

        return idsLiberaveis.length > 0;
    }

    public podeDesfazerLiberacaoSelecionados(): boolean {
        if (this.desfazerLiberacaoLoteBusy || this.liberacaoLoteBusy) {
            return false;
        }

        const situacoes = this.obterSituacoesSelecionadas();

        if (situacoes.size !== 1) {
            return false;
        }

        const [situacao] = Array.from(situacoes);

        if (situacao !== 'Pendente de assinatura' && situacao !== 'Entregue') {
            return false;
        }

        return this.documentosParaDesfazerLiberacao().length > 0;
    }

    public podeReenviarSelecionados(): boolean {
        if (this.reenviarLoteBusy || this.liberacaoLoteBusy || this.desfazerLiberacaoLoteBusy) {
            return false;
        }

        const situacoes = this.obterSituacoesSelecionadas();

        if (situacoes.size !== 1) {
            return false;
        }

        const [situacao] = Array.from(situacoes);

        if (situacao !== 'Pendente de assinatura' && situacao !== 'Entregue') {
            return false;
        }

        return this.coletarIdsDocumentosPendenteAssinaturaSelecionados().length > 0;
    }

    public selecaoComSituacoesDiferentes(): boolean {
        if (!Array.isArray(this.checkboxPreenchidos) || !this.checkboxPreenchidos.length) {
            return false;
        }

        const situacoes = this.obterSituacoesSelecionadas();
        return situacoes.size > 1;
    }

    public liberarDocumentosSelecionados(): void {
        const documentosIds = this.coletarIdsDocumentosLiberaveisSelecionados();

        if (!documentosIds.length || this.liberacaoLoteBusy || this.desfazerLiberacaoLoteBusy || !this.podeLiberarSelecionados()) {
            return;
        }

        this.busy = true;
        this.liberacaoLoteBusy = true;

        this.GerenciamentoDocumentosService.liberarDocumentosLote(documentosIds)
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Documentos liberados com sucesso!'
                });

                this.checkboxPreenchidos = [];
                this.filterReload();
            })
            .catch((error) => {
                console.error('Erro ao liberar documentos em lote:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao liberar documentos',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar liberar os documentos. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
                this.liberacaoLoteBusy = false;
            });
    }

    public desfazerLiberacaoSelecionados(): void {
        const documentosIds = this.documentosParaDesfazerLiberacao();

        if (!documentosIds.length || this.desfazerLiberacaoLoteBusy || this.liberacaoLoteBusy || !this.podeDesfazerLiberacaoSelecionados()) {
            return;
        }

        this.busy = true;
        this.desfazerLiberacaoLoteBusy = true;

        this.GerenciamentoDocumentosService.desfazerLiberacaoDocumentosLote(documentosIds)
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Liberação desfeita com sucesso!'
                });

                this.checkboxPreenchidos = [];
                this.filterReload();
            })
            .catch((error) => {
                console.error('Erro ao desfazer liberação dos documentos:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao desfazer liberação',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar desfazer a liberação. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
                this.desfazerLiberacaoLoteBusy = false;
            });
    }

    public reenviarDocumentosSelecionados(): void {
        const documentosIds = this.coletarIdsDocumentosPendenteAssinaturaSelecionados();

        if (!documentosIds.length || this.reenviarLoteBusy || this.liberacaoLoteBusy || this.desfazerLiberacaoLoteBusy || !this.podeReenviarSelecionados()) {
            return;
        }

        this.busy = true;
        this.reenviarLoteBusy = true;

        this.GerenciamentoDocumentosService.reenviarDocumentosLote(documentosIds)
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Documentos reenviados com sucesso!'
                });

                this.checkboxPreenchidos = [];
            })
            .catch((error) => {
                console.error('Erro ao reenviar documentos em lote:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao reenviar documentos',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar reenviar os documentos. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
                this.reenviarLoteBusy = false;
            });
    }

    public desfazerLiberacao(documento: IGerenciamentoDocumento): void {
        if (!documento.arquivotrabalhador) {
            console.error('Documento sem ID de arquivo');
            return;
        }

        if (!this.podeDesfazerLiberacao(documento)) {
            return;
        }

        this.busy = true;

        this.GerenciamentoDocumentosService.desfazerLiberacaoDocumento(documento.arquivotrabalhador)
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Liberação desfeita com sucesso!'
                });

                this.filterReload();
            })
            .catch((error) => {
                console.error('Erro ao desfazer liberação do documento:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao desfazer liberação',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar desfazer a liberação. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    public reenviarDocumento(documento: IGerenciamentoDocumento): void {
        if (!documento?.arquivotrabalhador) {
            console.error('Documento sem ID de arquivo');
            return;
        }

        if (!this.podeReenviar(documento)) {
            return;
        }

        this.busy = true;

        this.GerenciamentoDocumentosService.reenviarDocumento(documento.arquivotrabalhador)
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Documento reenviado com sucesso!'
                });
            })
            .catch((error) => {
                console.error('Erro ao reenviar documento:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao reenviar documento',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar reenviar o documento. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    public podeExcluir(documento: IGerenciamentoDocumento): boolean {
        return documento.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteLiberacao
            || documento.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteAssinatura;
    }

    public excluirDocumento(documento: IGerenciamentoDocumento): void {
        if (!documento?.arquivotrabalhador) {
            console.error('Documento sem ID de arquivo');
            return;
        }

        if (!this.podeExcluir(documento)) {
            return;
        }

        this.confirmarEExcluirDocumento(documento);
    }

    public podeExcluirSelecionados(): boolean {
        if (this.exclusaoLoteBusy || this.liberacaoLoteBusy || this.desfazerLiberacaoLoteBusy || this.reenviarLoteBusy) {
            return false;
        }

        const ids = this.coletarIdsDocumentosExcluiveisSelecionados();
        return ids.length > 0;
    }

    public excluirDocumentosSelecionados(): void {
        const documentosIds = this.coletarIdsDocumentosExcluiveisSelecionados();

        if (!documentosIds.length || this.exclusaoLoteBusy || !this.podeExcluirSelecionados()) {
            return;
        }

        const temPendenteAssinatura = this.checkboxPreenchidos.some(
            (doc) => doc.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteAssinatura && this.podeExcluir(doc)
        );

        this.confirmarEExcluirLote(documentosIds, temPendenteAssinatura);
    }

    public podeBaixarSelecionados(): boolean {
        if (this.downloadLoteBusy || this.exclusaoLoteBusy || this.liberacaoLoteBusy || this.desfazerLiberacaoLoteBusy || this.reenviarLoteBusy) {
            return false;
        }

        // download vale para qualquer situacao: nao depende de selecao homogenea
        return this.coletarDocumentosSelecionados().length > 0;
    }

    public baixarDocumentosSelecionados(): void {
        const documentos = this.coletarDocumentosSelecionados();

        if (!documentos.length || !this.podeBaixarSelecionados()) {
            return;
        }

        if (documentos.length > LIMITE_DOWNLOAD_LOTE) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Muitos documentos selecionados',
                body: `Selecione no máximo ${LIMITE_DOWNLOAD_LOTE} documentos por download em lote.`
            });
            return;
        }

        this.busy = true;
        this.downloadLoteBusy = true;

        // com um unico documento o zip so adiciona um passo: baixa o arquivo direto
        const download = documentos.length === 1
            ? this.baixarArquivoIndividual(documentos[0])
            : this.baixarArquivosEmZip(documentos);

        download
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Download realizado com sucesso!'
                });

                this.checkboxPreenchidos = [];
            })
            .catch((error) => {
                console.error('Erro ao baixar documentos selecionados:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao baixar documentos',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar baixar os documentos. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
                this.downloadLoteBusy = false;
            });
    }

    private definirColunaData(coluna: any, valor: string, rotulo: string): void {
        coluna.value = valor;
        // o label alimenta o data-label do mobile; o rotulo, o cabecalho.
        coluna.label = rotulo;
        this.rotuloColunaData = rotulo;
    }

    private resolveActiveTabIndex(situacao?: GerenciamentoDocumentoSituacao): number {
        if (!situacao) {
            return this.situacoesDocumentos.length;
        }

        const index = this.situacoesDocumentos.findIndex((item) => item.value === situacao);
        return index === -1 ? this.situacoesDocumentos.length : index;
    }

    private devePaginarPendentesAutomaticamente(): boolean {
        return this.filters?.situacao === GerenciamentoDocumentoSituacao.PendenteLiberacao
            || this.filters?.situacao === GerenciamentoDocumentoSituacao.PendenteAssinatura;
    }

    private hasSearchActive(): boolean {
        return !!this.normalizeSearchValue(this.searchTerm)
            || !!this.normalizeSearchValue(this.filters.camposCustomizados?.tipo_calculo);
    }

    private updateLoadMoreState(hasSearch: boolean): void {
        if (!this.entityService?.loadParams) {
            return;
        }

        if (hasSearch) {
            this.entityService.loadParams.finished = true;
            return;
        }

        this.entityService.loadParams.finished = !this.hasNextPage;
    }

    private addDestroyListener(unregister: (() => void) | undefined): void {
        if (typeof unregister === 'function') {
            this.destroyListeners.push(unregister);
        }
    }

    private onDestroy(): void {
        while (this.destroyListeners.length) {
            const unregister = this.destroyListeners.pop();
            if (typeof unregister === 'function') {
                unregister();
            }
        }

        this.GerenciamentoDocumentosService.resetState();
        this.entities = this.GerenciamentoDocumentosService.entities;
        this.checkboxPreenchidos = [];
        this.totalItems = 0;
        this.totalPendenteLiberacao = 0;
        this.totalPendenteAssinatura = 0;
    }

    private getTipoDocumentoSelecionado(): ITipoDocumento | undefined {
        if (!this.filters.tipodocumento) {
            return undefined;
        }

        return this.tiposDocumentos.find((tipoDocumento) => tipoDocumento.id === this.filters.tipodocumento);
    }

    private getCampoCustomizadoTipo(campo: string | ICampoCustomizadoConfiguracao): CampoCustomizadoTipo {
        const configuracao = this.normalizarCampoCustomizadoConfiguracao(campo);

        if (!configuracao) {
            return 'text';
        }

        const tipoBackend = (configuracao.tipo || '').toLowerCase().trim();

        if (tipoBackend === 'data' || tipoBackend === 'date') {
            return 'date';
        }

        if (configuracao.campo === 'tipo_calculo') {
            return 'select';
        }

        if (tipoBackend === 'select' || tipoBackend === 'selecao') {
            return 'select';
        }

        if (tipoBackend === 'texto' || tipoBackend === 'text') {
            return this.camposCustomizadosDefinicoes[configuracao.campo]?.tipo || 'text';
        }

        return this.camposCustomizadosDefinicoes[configuracao.campo]?.tipo || 'text';
    }

    private normalizarFiltrosEspecificosTipoSelecionado(): void {
        const tipoDocumentoSelecionado = this.getTipoDocumentoSelecionado();
        const camposConfigurados = this.normalizarCamposCustomizadosConfigurados(
            tipoDocumentoSelecionado?.filtros_especificos?.campos_customizados
        );
        const camposPermitidos = new Set(camposConfigurados.map((campo) => campo.campo).filter((campo) => !!campo));
        const tipoDocumentoSemCompetencia = !!tipoDocumentoSelecionado
            && !tipoDocumentoSelecionado.filtros_especificos?.usar_competencia;
        const filtrosCustomizadosAtuais = this.filters.camposCustomizados || {};
        const filtrosCustomizadosNormalizados: Record<string, any> = {};

        this.camposCustomizadosConfigurados = camposConfigurados;

        if (tipoDocumentoSemCompetencia) {
            delete this.filters.competenciaano;
            delete this.filters.competenciames;
        }

        Object.keys(filtrosCustomizadosAtuais).forEach((campo) => {
            if (!camposPermitidos.has(campo)) {
                return;
            }

            const valorFormatado = this.formatCampoCustomizadoValor(campo, filtrosCustomizadosAtuais[campo]);

            if (valorFormatado !== null) {
                filtrosCustomizadosNormalizados[campo] = valorFormatado;
            }
        });

        this.filters.camposCustomizados = filtrosCustomizadosNormalizados;
    }

    private refreshCamposCustomizadosConfigurados(): void {
        this.camposCustomizadosConfigurados = this.camposCustomizadosConfigurados.map((campo) => ({
            ...campo,
            opcoes: this.getCampoCustomizadoOpcoes(campo.campo)
        }));
    }

    private normalizarCamposCustomizadosConfigurados(
        campos?: Array<string | ICampoCustomizadoConfiguracao>
    ): ICampoCustomizadoConfiguracao[] {
        if (!Array.isArray(campos)) {
            return [];
        }

        return campos
            .map((campo) => this.normalizarCampoCustomizadoConfiguracao(campo))
            .filter((campo): campo is ICampoCustomizadoConfiguracao => !!campo);
    }

    private getCampoCustomizadoNome(campo: string | ICampoCustomizadoConfiguracao): string {
        if (typeof campo === 'string') {
            return campo;
        }

        return campo?.campo || '';
    }

    private normalizarCampoCustomizadoConfiguracao(
        campo: string | ICampoCustomizadoConfiguracao
    ): ICampoCustomizadoConfiguracao | null {
        if (typeof campo === 'string') {
            return {
                campo,
                label: this.camposCustomizadosDefinicoes[campo]?.label || campo,
                tipo: this.camposCustomizadosDefinicoes[campo]?.tipo || 'text',
                opcoes: this.getCampoCustomizadoOpcoes(campo)
            };
        }

        if (!campo || !campo.campo) {
            return null;
        }

        return {
            campo: campo.campo,
            label: campo.label || this.camposCustomizadosDefinicoes[campo.campo]?.label || campo.campo,
            tipo: campo.tipo || this.camposCustomizadosDefinicoes[campo.campo]?.tipo || 'text',
            opcoes: this.getCampoCustomizadoOpcoes(campo.campo)
        };
    }

    private getCampoCustomizadoOpcoes(campo: string): Array<{ id: string; nome: string }> {
        if (campo !== 'tipo_calculo' || !Array.isArray(this.tiposCalculos)) {
            if (campo !== 'tipo_calculo') {
                return [];
            }
        }

        const valoresDocumentos = (this.entityService?.entities || [])
            .map((documento) => this.extrairValoresTipoCalculo(documento?.campos_customizados?.tipo_calculo))
            .reduce<string[]>((acumulado, valores) => acumulado.concat(valores), []);

        const opcoesDocumentos = Array.from(new Set(
            valoresDocumentos.filter((valor) => !!valor.trim())
        )).map((valor) => ({
            id: valor,
            nome: valor
        }));

        if (opcoesDocumentos.length) {
            return this.ordenarOpcoesCampoCustomizado(opcoesDocumentos);
        }

        return this.ordenarOpcoesCampoCustomizado(
            (this.tiposCalculos || [])
                .filter((tipoCalculo) => !!tipoCalculo?.descricao)
                .map((tipoCalculo) => ({
                    id: tipoCalculo.descricao,
                    nome: tipoCalculo.descricao
                }))
        );
    }

    private ordenarOpcoesCampoCustomizado(
        opcoes: Array<{ id: string; nome: string }>
    ): Array<{ id: string; nome: string }> {
        return [...opcoes].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' }));
    }

    private buildCamposCustomizadosParams(): Record<string, string> {
        const camposCustomizados = this.filters.camposCustomizados || {};
        const camposCustomizadosNormalizados: Record<string, string> = {};

        Object.keys(camposCustomizados).forEach((campo) => {
            if (campo === 'tipo_calculo') {
                return;
            }

            const valorFormatado = this.formatCampoCustomizadoValor(campo, camposCustomizados[campo]);

            if (valorFormatado !== null) {
                camposCustomizadosNormalizados[campo] = valorFormatado;
            }
        });

        return camposCustomizadosNormalizados;
    }

    private formatCampoCustomizadoValor(campo: string, valor: any): string | null {
        if (valor === null || valor === undefined) {
            return null;
        }

        if (moment.isMoment(valor)) {
            return this.formatarValorDataCampoCustomizado(valor.format('YYYY-MM-DD'));
        }

        if (valor instanceof Date && !Number.isNaN(valor.getTime())) {
            return this.formatarValorDataCampoCustomizado(moment(valor).format('YYYY-MM-DD'));
        }

        const valorTexto = valor.toString().trim();

        if (!valorTexto) {
            return null;
        }

        if (this.getCampoCustomizadoTipo(campo) === 'date') {
            return this.formatarValorDataCampoCustomizado(valorTexto);
        }

        return valorTexto;
    }

    private formatarValorDataCampoCustomizado(valor: string): string {
        const formatosSuportados = ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601];
        const dataFormatada = moment(valor, formatosSuportados, true);

        if (dataFormatada.isValid()) {
            return dataFormatada.format('YYYY-MM-DD');
        }

        return valor;
    }

    private extrairValoresTipoCalculo(valor?: string | null): string[] {
        if (typeof valor !== 'string' || !valor.trim()) {
            return [];
        }

        return valor
            .split(',')
            .map((item) => item.trim())
            .filter((item) => !!item);
    }

    private coletarIdsDocumentosLiberaveisSelecionados(): string[] {
        if (!Array.isArray(this.checkboxPreenchidos) || !this.checkboxPreenchidos.length) {
            return [];
        }

        const ids = this.checkboxPreenchidos
            .filter((documento) => this.podeLiberar(documento) && !!documento.arquivotrabalhador)
            .map((documento) => documento.arquivotrabalhador as string);

        return Array.from(new Set(ids));
    }

    private documentosParaDesfazerLiberacao(): string[] {
        if (!Array.isArray(this.checkboxPreenchidos) || !this.checkboxPreenchidos.length) {
            return [];
        }

        const ids = this.checkboxPreenchidos
            .filter((documento) => this.podeDesfazerLiberacao(documento) && !!documento.arquivotrabalhador)
            .map((documento) => documento.arquivotrabalhador as string);

        return Array.from(new Set(ids));
    }

    private coletarIdsDocumentosPendenteAssinaturaSelecionados(): string[] {
        if (!Array.isArray(this.checkboxPreenchidos) || !this.checkboxPreenchidos.length) {
            return [];
        }

        const ids = this.checkboxPreenchidos
            .filter((documento) =>
                (documento.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteAssinatura ||
                    documento.situacaoAtual === GerenciamentoDocumentoSituacao.Entregue) &&
                !!documento.arquivotrabalhador
            )
            .map((documento) => documento.arquivotrabalhador as string);

        return Array.from(new Set(ids));
    }

    private obterSituacoesSelecionadas(): Set<string> {
        const situacoes = new Set<string>();

        if (!Array.isArray(this.checkboxPreenchidos)) {
            return situacoes;
        }

        this.checkboxPreenchidos.forEach((documento) => {
            const situacao = documento?.situacaoAtual ? this.situacaoLabels[documento.situacaoAtual] : documento?.situacaoAtualLabel;
            const chave = situacao || '__situacao_indefinida__';
            situacoes.add(chave);
        });

        return situacoes;
    }

    private executarCancelamentoAssinatura(documento: IGerenciamentoDocumento, comentario: string): void {
        if (!this.podeCancelarAssinatura(documento) || !comentario || !comentario.trim()) {
            return;
        }

        this.busy = true;
        this.cancelamentoAssinaturaBusy = true;

        this.GerenciamentoDocumentosService
            .cancelarAssinatura(documento.arquivotrabalhador, comentario)
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Documento cancelado com sucesso!'
                });

                this.checkboxPreenchidos = [];
                this.filterReload();
            })
            .catch((error) => {
                console.error('Erro ao cancelar documento:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao cancelar documento',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar cancelar o documento. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
                this.cancelamentoAssinaturaBusy = false;
            });
    }

    private handleDownload(file: Blob, name: string, type?: string): void {
        const blob = new Blob([file], { type });
        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(fileURL);
        document.body.removeChild(a);
    }

    private resolverNomeArquivoDownload(response: angular.IHttpResponse<Blob>, documento: IGerenciamentoDocumento): string {
        return resolverNomeArquivoDownload(
            response.headers('Content-Disposition'),
            this.montarNomeArquivoPadronizado(documento),
            documento.extensao,
            'documento'
        );
    }

    /**
     * Nome do arquivo baixado: "{colaborador} - {matricula} - {tipo} - {MM-AAAA}", omitindo
     * segmentos sem valor. Duplicado no backend de proposito: a API responde de outra origem e
     * nao expoe Content-Disposition, entao o browser nao le o nome enviado pelo servidor.
     */
    private montarNomeArquivoPadronizado(documento: IGerenciamentoDocumento): string {
        const titulo = this.normalizarSegmentoNomeArquivo(
            documento?.tipoarquivo?.titulo || documento?.tipoarquivo?.descricao
        );

        const segmentos = [
            documento?.trabalhadorDisplay || documento?.trabalhador?.nome,
            documento?.matricula || documento?.trabalhador?.codigo,
            titulo,
            this.montarNomeProprioDocumento(documento, titulo),
            this.montarCompetenciaNomeArquivo(documento)
        ];

        const nome = segmentos
            .map((segmento) => this.normalizarSegmentoNomeArquivo(segmento))
            .filter((segmento) => !!segmento)
            .join(' - ')
            .substring(0, TAMANHO_MAXIMO_NOME_ARQUIVO);

        return montarNomeArquivoComExtensao(nome, documento?.extensao, 'documento');
    }

    /**
     * A coluna nome identifica o documento quando quem gravou a informou (ex.: "RG frente").
     * Quando ela comeca pelo titulo do tipo, e o proprio titulo mais a competencia, e nao
     * acrescenta informacao ao nome do arquivo.
     */
    private montarNomeProprioDocumento(documento: IGerenciamentoDocumento, titulo: string): string {
        const nome = this.normalizarSegmentoNomeArquivo(documento?.nome);

        if (!nome || !titulo) {
            return nome;
        }

        return nome.toLowerCase().indexOf(titulo.toLowerCase()) === 0 ? '' : nome;
    }

    /**
     * Deriva a competencia dos campos crus, os mesmos que o backend usa. O campo referencia
     * nao serve aqui: e valor de exibicao da listagem, com o mes por extenso.
     */
    private montarCompetenciaNomeArquivo(documento: IGerenciamentoDocumento): string {
        const ano = documento?.competenciaano;

        if (!ano) {
            return '';
        }

        const mes = documento?.competenciames;

        return mes ? `${('0' + mes).slice(-2)}-${ano}` : `${ano}`;
    }

    private normalizarSegmentoNomeArquivo(segmento?: string | null): string {
        if (!segmento || segmento === '-') {
            return '';
        }

        // classe explicita em vez de \p{L}: unicode property escapes exigem ES2018 no motor,
        // e nada no build transpila literais de regex - em navegador antigo o bundle nem parseia
        return segmento
            .replace(/[\\/]+/g, ' ')
            .replace(/[^0-9A-Za-z\u00AA\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF_\-. ]/g, '')
            .replace(/\s+/g, ' ')
            .replace(/^[\s.]+|[\s.]+$/g, '');
    }

    private montarNomeZipDownloadLote(): string {
        return `documentos_${moment().format('DD-MM-YYYY')}.zip`;
    }

    private baixarArquivoIndividual(documento: IGerenciamentoDocumento): angular.IPromise<void> {
        return this.GerenciamentoDocumentosService
            .getArquivo(documento.arquivotrabalhador)
            .then((response) => {
                const nomeArquivo = this.resolverNomeArquivoDownload(response, documento);
                this.handleDownload(response.data, nomeArquivo, 'application/octet-stream');
            });
    }

    private baixarArquivosEmZip(documentos: IGerenciamentoDocumento[]): angular.IPromise<void> {
        const arquivos = documentos.map((documento) => ({
            arquivotrabalhador: documento.arquivotrabalhador as string
        }));

        return this.MeurhArquivosTrabalhadorService
            .downloadArquivos(arquivos)
            .then((zip) => {
                this.handleDownload(zip, this.montarNomeZipDownloadLote(), 'application/zip');
            });
    }

    private coletarDocumentosSelecionados(): IGerenciamentoDocumento[] {
        if (!Array.isArray(this.checkboxPreenchidos) || !this.checkboxPreenchidos.length) {
            return [];
        }

        const idsVistos = new Set<string>();

        return this.checkboxPreenchidos.filter((documento) => {
            const id = documento.arquivotrabalhador;

            if (!id || idsVistos.has(id)) {
                return false;
            }

            idsVistos.add(id);
            return true;
        });
    }

    private resolverExtensaoDocumento(documento: IGerenciamentoDocumento): string {
        if (documento?.extensao) {
            return documento.extensao.replace(/^\./, '').toLowerCase();
        }

        const nomeArquivo = documento?.nome || '';
        const partesNome = nomeArquivo.split('.');
        const extensaoInferida = partesNome.length > 1 ? partesNome.pop() : '';

        return (extensaoInferida || '').replace(/^\./, '').toLowerCase();
    }

    private transformarHistorico(historicoAPI: any[]): IGerenciamentoDocumentoHistorico[] {
        if (!Array.isArray(historicoAPI)) {
            return [];
        }

        return historicoAPI.map((item) => {
            const dataHora = moment(item.created_at);
            const dataHoraFormatada = dataHora.isValid()
                ? dataHora.format('DD/MM/YYYY [às] HH:mm')
                : '';

            const responsavel = item.created_by?.nome || '';

            return {
                id: item.arquivotrabalhadorhistorico || '',
                titulo: item.acao || '',
                dataHora: dataHoraFormatada,
                descricao: item.mensagem || '',
                responsavel: responsavel,
                categoria: this.determinarCategoriaHistorico(item)
            };
        });
    }

    private determinarCategoriaHistorico(item: any): 'falha' | 'manual' | 'sistema' {
        const acao = (item.acao || '').toLowerCase();
        const mensagem = (item.mensagem || '').toLowerCase();

        if (acao.includes('erro') || acao.includes('falha') || mensagem.includes('erro') || mensagem.includes('falha')) {
            return 'falha';
        }

        if (item.created_by?.nome) {
            return 'manual';
        }

        return 'sistema';
    }

    private confirmarEExcluirDocumento(documento: IGerenciamentoDocumento): void {
        const identificacao = `O documento "${documento.tipoarquivoTitulo || documento.tipoarquivo?.titulo || ''}" de ${documento.trabalhadorDisplay || documento.trabalhador?.nome || ''}`;
        const jaLiberado = documento.situacaoAtual === GerenciamentoDocumentoSituacao.PendenteAssinatura;

        const textos = {
            titulo: 'Excluir documento',
            descricao: jaLiberado
                ? `${identificacao} já foi liberado e pode ter sido visualizado pelo colaborador.`
                : `${identificacao} será excluído.`,
            textoConfirmacao: 'Tem certeza que deseja excluir este documento?',
            botoes: {
                fechar: 'Cancelar',
                confirmar: 'Excluir'
            }
        };

        const modalInstance = this.ConfirmacaoExclusaoModalService.open(textos);

        modalInstance.result.then(() => {
            this.executarExclusao(documento);
        }).catch(() => { /* cancelado */ });
    }

    private executarExclusao(documento: IGerenciamentoDocumento): void {
        this.busy = true;

        this.GerenciamentoDocumentosService.excluirDocumento(documento.arquivotrabalhador)
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Documento excluído com sucesso!'
                });

                this.filterReload();
            })
            .catch((error) => {
                console.error('Erro ao excluir documento:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao excluir documento',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar excluir o documento. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    private confirmarEExcluirLote(documentosIds: string[], temPendenteAssinatura: boolean): void {
        const textos = {
            titulo: 'Excluir documentos',
            descricao: temPendenteAssinatura
                ? 'A seleção contém documentos que já foram liberados e podem ter sido visualizados pelos colaboradores.'
                : undefined,
            textoConfirmacao: `Tem certeza que deseja excluir ${documentosIds.length} documento(s)?`,
            botoes: {
                fechar: 'Cancelar',
                confirmar: 'Excluir'
            }
        };

        const modalInstance = this.ConfirmacaoExclusaoModalService.open(textos);

        modalInstance.result.then(() => {
            this.executarExclusaoLote(documentosIds);
        }).catch(() => { /* cancelado */ });
    }

    private executarExclusaoLote(documentosIds: string[]): void {
        this.busy = true;
        this.exclusaoLoteBusy = true;

        this.GerenciamentoDocumentosService.excluirDocumentosLote(documentosIds)
            .then((resultado) => {
                this.notificarResultadoExclusaoLote(resultado, documentosIds.length);

                // mesmo com falha em parte dos itens, os demais podem ter sido excluidos.
                this.checkboxPreenchidos = [];
                this.filterReload();
            })
            .catch((error) => {
                console.error('Erro ao excluir documentos em lote:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao excluir documentos',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar excluir os documentos. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
                this.exclusaoLoteBusy = false;
            });
    }

    private notificarResultadoExclusaoLote(resultado: IExclusaoLoteResultado, totalSolicitado: number): void {
        const erros = Array.isArray(resultado?.erros) ? resultado.erros : [];

        if (!erros.length) {
            this.NewToaster.pop({
                type: 'success',
                title: 'Documentos excluídos com sucesso!'
            });
            return;
        }

        const totalExcluidos = Array.isArray(resultado?.excluidos)
            ? resultado.excluidos.length
            : totalSolicitado - erros.length;
        const motivos = Array.from(new Set(erros.map((erro) => erro.motivo).filter(Boolean))).join(' ');

        if (!totalExcluidos) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Erro ao excluir documentos',
                body: motivos || 'Nenhum documento pôde ser excluído. Tente novamente.'
            });
            return;
        }

        this.NewToaster.pop({
            type: 'warning',
            title: `${totalExcluidos} documento(s) excluído(s)`,
            body: `${erros.length} documento(s) não puderam ser excluídos${motivos ? `: ${motivos}` : '.'}`
        });
    }

    private coletarIdsDocumentosExcluiveisSelecionados(): string[] {
        if (!Array.isArray(this.checkboxPreenchidos) || !this.checkboxPreenchidos.length) {
            return [];
        }

        const ids = this.checkboxPreenchidos
            .filter((documento) => this.podeExcluir(documento) && !!documento.arquivotrabalhador)
            .map((documento) => documento.arquivotrabalhador as string);

        return Array.from(new Set(ids));
    }
}
